export interface CredentialsCreationCardProps {
    createHandler: (data: CreationData) => void;
    isEdit?: boolean;
    credentialName?: string;
    expirationDateType?: string;
    expirationAmount?: number;
    onBack?: () => void;
    isDisabled?: boolean;
}

export enum DateTypes {
    Hours = 'h',
    Days = 'd',
    Months = 'm',
    Years = 'y'
}

export interface CreationData {
    amount: number;
    dateType: string;
    name: string;
}
